import React, { useState } from "react";
import { Megaphone, Send, X } from "lucide-react";
import api, { apiError } from "@/lib/api";

export default function BannerInquiryCard() {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="stb-card p-5 relative overflow-hidden bg-[#0E0E0E]"
      data-testid="banner-inquiry-card"
    >
      <span className="stb-label inline-flex items-center gap-2 text-[#A3A3A3]">
        <Megaphone size={12} className="text-[#FF6B00]" /> Reklamní prostor
      </span>
      <h3 className="stb-h text-2xl text-white mt-2 leading-tight">
        Prostor pro Váš <span className="text-[#FF6B00]">reklamní banner</span> na 14 dnů
      </h3>
      <p className="text-sm text-[#A3A3A3] mt-2">
        Chcete oslovit stovky stavbařů, řemeslníků a firem? Pošlete nám poptávku –
        ozveme se obratem s nabídkou a podmínkami.
      </p>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="stb-btn stb-btn-primary w-full mt-4 justify-center"
        data-testid="banner-inquiry-open-btn"
      >
        <Send size={14} /> Mám zájem o reklamu
      </button>
      {open && <BannerInquiryModal onClose={() => setOpen(false)} />}
    </div>
  );
}

function BannerInquiryModal({ onClose }) {
  const [form, setForm] = useState({
    company: "", ic: "", dic: "", phone: "", email: "", message: "",
  });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/banner-inquiry", {
        company: form.company.trim(),
        ic: form.ic.trim(),
        dic: form.dic.trim() || null,
        phone: form.phone.trim() || null,
        email: form.email.trim(),
        message: form.message.trim(),
      });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="banner-inquiry-modal"
    >
      <div className="stb-card-static p-5 w-full max-w-lg relative" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-[#A3A3A3] hover:text-[#FF6B00]"
          aria-label="Zavřít"
        >
          <X size={18} />
        </button>
        <h3 className="stb-h text-xl text-white inline-flex items-center gap-2">
          <Megaphone size={18} className="text-[#FF6B00]" /> Poptávka reklamního banneru
        </h3>
        {done ? (
          <div className="mt-4 text-center" data-testid="banner-inquiry-done">
            <p className="stb-h text-[#22C55E] text-lg">Poptávka odeslána ✓</p>
            <p className="text-[#A3A3A3] text-sm mt-1">
              Ozveme se do 24 hodin s konkrétní nabídkou. Děkujeme!
            </p>
            <button onClick={onClose} className="stb-btn stb-btn-primary mt-4">Zavřít</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-3 space-y-2">
            <input
              className="stb-input"
              placeholder="Název firmy *"
              required maxLength={120}
              value={form.company}
              onChange={(e) => setForm({ ...form, company: e.target.value })}
              data-testid="banner-inquiry-company"
            />
            <div className="grid grid-cols-2 gap-2">
              <input
                className="stb-input" placeholder="IČO *" required
                value={form.ic} onChange={(e) => setForm({ ...form, ic: e.target.value })}
                data-testid="banner-inquiry-ic"
              />
              <input
                className="stb-input" placeholder="DIČ (volitelné)"
                value={form.dic} onChange={(e) => setForm({ ...form, dic: e.target.value })}
                data-testid="banner-inquiry-dic"
              />
            </div>
            <input
              className="stb-input" placeholder="Telefon (volitelné)"
              value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
              data-testid="banner-inquiry-phone"
            />
            <input
              type="email" className="stb-input" placeholder="E-mail *" required
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="banner-inquiry-email"
            />
            <textarea
              className="stb-input" rows={4}
              placeholder="Zpráva – co byste rádi propagovali, na jaké stránce, jaká doba… *"
              required maxLength={4000}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              data-testid="banner-inquiry-message"
            />
            {error && (
              <p className="text-[#FF6B00] text-sm" data-testid="banner-inquiry-error">{error}</p>
            )}
            <div className="flex gap-2">
              <button
                type="submit" disabled={busy}
                className="stb-btn stb-btn-primary flex-1"
                data-testid="banner-inquiry-submit"
              >
                <Send size={14} /> {busy ? "Odesílám…" : "Odeslat poptávku"}
              </button>
              <button type="button" onClick={onClose} className="stb-btn stb-btn-ghost">Zrušit</button>
            </div>
            <p className="stb-mono text-[10px] text-[#A3A3A3] text-center mt-1">
              Poptávka jde na <strong>stavbos@post.cz</strong>. Odpovíme do 24 h.
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
